module.exports = __webpack_public_path__ + "static/media/close.b77e0429.svg";